export const RightArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
        stroke="#6941C6"
        strokeWidth="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CheckoutLockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        opacity="0.12"
        d="M4.5 15.8C4.5 14.1198 4.5 13.2798 4.82698 12.638C5.1146 12.0735 5.57354 11.6146 6.13803 11.327C6.77976 11 7.61984 11 9.3 11H15.7C17.3802 11 18.2202 11 18.862 11.327C19.4265 11.6146 19.8854 12.0735 20.173 12.638C20.5 13.2798 20.5 14.1198 20.5 15.8V16.2C20.5 17.8802 20.5 18.7202 20.173 19.362C19.8854 19.9265 19.4265 20.3854 18.862 20.673C18.2202 21 17.3802 21 15.7 21H9.3C7.61984 21 6.77976 21 6.13803 20.673C5.57354 20.3854 5.1146 19.9265 4.82698 19.362C4.5 18.7202 4.5 17.8802 4.5 16.2V15.8Z"
        fill="black"
      />
      <path
        d="M17.5 11V8C17.5 5.23858 15.2614 3 12.5 3C9.73858 3 7.5 5.23858 7.5 8V11M9.3 21H15.7C17.3802 21 18.2202 21 18.862 20.673C19.4265 20.3854 19.8854 19.9265 20.173 19.362C20.5 18.7202 20.5 17.8802 20.5 16.2V15.8C20.5 14.1198 20.5 13.2798 20.173 12.638C19.8854 12.0735 19.4265 11.6146 18.862 11.327C18.2202 11 17.3802 11 15.7 11H9.3C7.61984 11 6.77976 11 6.13803 11.327C5.57354 11.6146 5.1146 12.0735 4.82698 12.638C4.5 13.2798 4.5 14.1198 4.5 15.8V16.2C4.5 17.8802 4.5 18.7202 4.82698 19.362C5.1146 19.9265 5.57354 20.3854 6.13803 20.673C6.77976 21 7.61984 21 9.3 21Z"
        stroke="white"
        strokeWidth="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const ShoppingCartIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.50014 17H17.3294C18.2793 17 18.7543 17 19.1414 16.8284C19.4827 16.6771 19.7748 16.4333 19.9847 16.1246C20.2228 15.7744 20.3078 15.3071 20.4777 14.3724L21.8285 6.94311C21.8874 6.61918 21.9169 6.45721 21.8714 6.33074C21.8315 6.21979 21.7536 6.12651 21.6516 6.06739C21.5353 6 21.3707 6 21.0414 6H5.00014M2 2H3.3164C3.55909 2 3.68044 2 3.77858 2.04433C3.86507 2.0834 3.93867 2.14628 3.99075 2.22563C4.04984 2.31565 4.06876 2.43551 4.10662 2.67523L6.89338 20.3248C6.93124 20.5645 6.95016 20.6843 7.00925 20.7744C7.06133 20.8537 7.13493 20.9166 7.22142 20.9557C7.31956 21 7.44091 21 7.6836 21H19"
        stroke="#6941C6"
        strokeWidth="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SubscriptionTwoLayerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
    >
      <rect x="3" y="3" width="40" height="40" rx="20" fill="#F4EBFF" />
      <rect
        x="3"
        y="3"
        width="40"
        height="40"
        rx="20"
        stroke="#F9F5FF"
        strokeWidth="6"
      />
      <path
        d="M14.6667 25.0833L22.7019 29.1009C22.8112 29.1556 22.8658 29.1829 22.9232 29.1937C22.974 29.2032 23.0261 29.2032 23.0768 29.1937C23.1342 29.1829 23.1888 29.1556 23.2981 29.1009L31.3333 25.0833M14.6667 20.9167L22.7019 16.8991C22.8112 16.8444 22.8658 16.8171 22.9232 16.8063C22.974 16.7968 23.0261 16.7968 23.0768 16.8063C23.1342 16.8171 23.1888 16.8444 23.2981 16.8991L31.3333 20.9167L23.2981 24.9343C23.1888 24.9889 23.1342 25.0163 23.0768 25.027C23.0261 25.0365 22.974 25.0365 22.9232 25.027C22.8658 25.0163 22.8112 24.9889 22.7019 24.9343L14.6667 20.9167Z"
        stroke="#7F56D9"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SubscriptionPowerIcon = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="3" width="40" height="40" rx="20" fill="#F4EBFF" />
      <rect
        x="3"
        y="3"
        width="40"
        height="40"
        rx="20"
        stroke="#F9F5FF"
        strokeWidth="6"
      />
      <path
        d="M23.8334 14.6666L16.4112 23.5732C16.1206 23.922 15.9752 24.0964 15.973 24.2437C15.9711 24.3717 16.0281 24.4935 16.1277 24.574C16.2423 24.6666 16.4693 24.6666 16.9234 24.6666H23L22.1667 31.3333L29.5888 22.4267C29.8795 22.0779 30.0248 21.9035 30.027 21.7562C30.029 21.6282 29.9719 21.5064 29.8723 21.4259C29.7577 21.3333 29.5307 21.3333 29.0767 21.3333H23L23.8334 14.6666Z"
        stroke="#7F56D9"
        strokeWidth="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const RecordPlayerBtnIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6 16H14V15.45C14 14.7167 13.6333 14.125 12.9 13.675C12.1667 13.225 11.2 13 10 13C8.8 13 7.83333 13.225 7.1 13.675C6.36667 14.125 6 14.7167 6 15.45V16ZM10 12C10.55 12 11.0208 11.8042 11.4125 11.4125C11.8042 11.0208 12 10.55 12 10C12 9.45 11.8042 8.97917 11.4125 8.5875C11.0208 8.19583 10.55 8 10 8C9.45 8 8.97917 8.19583 8.5875 8.5875C8.19583 8.97917 8 9.45 8 10C8 10.55 8.19583 11.0208 8.5875 11.4125C8.97917 11.8042 9.45 12 10 12ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H16C16.55 4 17.0208 4.19583 17.4125 4.5875C17.8042 4.97917 18 5.45 18 6V10.5L22 6.5V17.5L18 13.5V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H4ZM4 18H16V6H4V18Z"
        fill="red"
      />
    </svg>
  );
};

export const RecordRestartBtnIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_305_243418)">
        <circle cx="28" cy="28" r="24" fill="#6941C6" />
        <circle cx="28" cy="28" r="22" stroke="white" strokeWidth="4" />
      </g>
      <path
        d="M27 36.95C24.9833 36.7 23.3125 35.8208 21.9875 34.3125C20.6625 32.8042 20 31.0333 20 29C20 27.9 20.2167 26.8458 20.65 25.8375C21.0833 24.8292 21.7 23.95 22.5 23.2L23.925 24.625C23.2917 25.1917 22.8125 25.85 22.4875 26.6C22.1625 27.35 22 28.15 22 29C22 30.4667 22.4667 31.7625 23.4 32.8875C24.3333 34.0125 25.5333 34.7 27 34.95V36.95ZM29 36.95V34.95C30.45 34.6833 31.6458 33.9917 32.5875 32.875C33.5292 31.7583 34 30.4667 34 29C34 27.3333 33.4167 25.9167 32.25 24.75C31.0833 23.5833 29.6667 23 28 23H27.925L29.025 24.1L27.625 25.5L24.125 22L27.625 18.5L29.025 19.9L27.925 21H28C30.2333 21 32.125 21.775 33.675 23.325C35.225 24.875 36 26.7667 36 29C36 31.0167 35.3375 32.7792 34.0125 34.2875C32.6875 35.7958 31.0167 36.6833 29 36.95Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_305_243418"
          x="0"
          y="0"
          width="56"
          height="56"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_305_243418"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_305_243418"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const RecordStopBtnIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_305_243418)">
        <circle cx="28" cy="28" r="24" fill="#D32A3F" />
        <circle cx="28" cy="28" r="22" stroke="white" strokeWidth="4" />
      </g>
      <g filter="url(#filter1_d_305_243418)">
        <circle cx="28" cy="28" r="10" fill="white" />
      </g>
      <defs>
        <filter
          id="filter0_d_305_243418"
          x="0"
          y="0"
          width="56"
          height="56"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_305_243418"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_305_243418"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_305_243418"
          x="14"
          y="14"
          width="28"
          height="28"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_305_243418"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_305_243418"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const OfferTagBtnIcon = () => {
  return (
    <svg
      width="85"
      height="50"
      viewBox="0 0 85 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M-9.15527e-05 15.9419L3.64438 11.7729L14.8468 21.3884L-9.15527e-05 15.9419Z"
        fill="#FFCB00"
      />
      <path
        d="M10.8594 14.9535L12.7421 13.1514L15.62 20.0638L10.8594 14.9535Z"
        fill="#FFCB00"
      />
      <path
        d="M46.7327 45.3936L43.4244 49.0247L30.4804 42.6905L46.7327 45.3936Z"
        fill="#FFCB00"
      />
      <path
        d="M35.4562 47.2966L33.708 48.9103L29.8214 43.8134L35.4562 47.2966Z"
        fill="#FFCB00"
      />
      <path
        d="M84.0517 6.10449C84.0825 5.24703 83.9272 4.39306 83.5964 3.60138C83.2656 2.80971 82.7671 2.09915 82.1353 1.51863C81.5054 0.945294 80.7576 0.516932 79.9444 0.263679C79.1312 0.0104266 78.2724 -0.0615672 77.4284 0.0527624L21.9206 7.77207C21.1334 7.87548 20.3762 8.141 19.6969 8.55186C19.0175 8.96273 18.4307 9.51001 17.9735 10.1591C17.5133 10.8049 17.1865 11.5359 17.0121 12.3095C16.8378 13.083 16.8194 13.8836 16.9582 14.6643L20.9456 35.8453C21.2085 37.2501 21.9754 38.5105 23.1022 39.3897C24.2289 40.2688 25.638 40.7062 27.0646 40.6195L77.4956 37.6272C78.9473 37.5417 80.3154 36.9198 81.3343 35.8823C82.3532 34.8447 82.9502 33.4656 83.0094 32.0126L84.0517 6.10449Z"
        fill="#FFCB00"
      />
      <path
        d="M44.043 35.7445C43.3687 35.8256 42.6847 35.7547 42.0413 35.5372C41.3979 35.3196 40.8113 34.9608 40.3245 34.4871C39.2483 33.4134 38.6188 31.9718 38.5628 30.4526C38.3376 28.8868 38.6837 27.2923 39.5378 25.9609C39.9344 25.3755 40.4602 24.8892 41.0746 24.5394C41.6891 24.1897 42.3757 23.9858 43.0815 23.9436C43.7477 23.86 44.4243 23.9298 45.0595 24.1477C45.6946 24.3657 46.2716 24.7259 46.7461 25.201C47.7904 26.295 48.4103 27.7255 48.4944 29.2355C48.7162 30.7905 48.37 32.3732 47.5194 33.6936C47.1413 34.2841 46.6297 34.7774 46.0258 35.1336C45.4219 35.4899 44.7427 35.6991 44.043 35.7445ZM43.2361 26.176C42.8565 26.2042 42.4905 26.329 42.1728 26.5385C41.855 26.748 41.5961 27.0352 41.4206 27.3729C40.9924 28.2195 40.8329 29.1767 40.9633 30.1164C40.9971 31.0644 41.3341 31.9765 41.9249 32.7186C42.1578 33.004 42.4579 33.227 42.7982 33.3679C43.1385 33.5087 43.5085 33.5629 43.8749 33.5255C44.2415 33.5031 44.5964 33.3884 44.9067 33.1921C45.2171 32.9958 45.4728 32.7242 45.6501 32.4026C46.081 31.5763 46.2365 30.6339 46.0939 29.7129C46.0559 28.7414 45.7254 27.8039 45.1458 27.0233C44.9315 26.7302 44.6446 26.4979 44.3133 26.3494C43.982 26.2008 43.6177 26.1411 43.2563 26.176H43.2361Z"
        fill="white"
      />
      <path
        d="M55.1714 25.1204L51.5874 25.4566L51.8631 28.2471L55.158 27.9311L55.3597 30.0088L52.0581 30.3316L52.4818 34.7561L50.1956 34.9712L49.1197 23.5873L55.0033 23.0359L55.1714 25.1204Z"
        fill="white"
      />
      <path
        d="M62.1444 24.4614L58.5672 24.7976L58.8361 27.5881L62.131 27.2721L62.3327 29.3566L59.0379 29.6793L59.4548 34.0971L57.1753 34.319L56.0927 22.935L61.9763 22.3836L62.1444 24.4614Z"
        fill="white"
      />
      <path
        d="M70.2134 33.075L64.1146 33.6398L63.0387 22.2626L68.9022 21.7112L69.1106 23.789L65.5267 24.1252L65.762 26.6535L69.1241 26.3643L69.3258 28.4488L65.9974 28.7716L66.2462 31.3738L70.0655 31.0174L70.2134 33.075Z"
        fill="white"
      />
      <path
        d="M79.7953 32.1672L77.1594 32.416L75.3103 29.6255C75.192 29.4283 75.057 29.2416 74.9068 29.0674C74.7957 28.9181 74.672 28.7786 74.537 28.6505C74.4292 28.5465 74.3041 28.4623 74.1672 28.4017C74.0383 28.3534 73.9013 28.3305 73.7637 28.3345L73.1451 28.3815L73.562 32.732L71.2758 32.9539L70.2 21.57L73.831 21.2338C76.2987 21.0051 77.6301 21.9062 77.8654 23.9772C77.9022 24.3483 77.8795 24.7228 77.7982 25.0867C77.7238 25.4218 77.5991 25.7437 77.4284 26.0415C77.2491 26.3351 77.0218 26.5965 76.756 26.8148C76.4836 27.0391 76.1829 27.2268 75.8617 27.3729C76.0291 27.4188 76.1881 27.4915 76.3324 27.5881C76.4887 27.7036 76.6391 27.827 76.7829 27.9579C76.9378 28.1043 77.0795 28.2641 77.2065 28.4353C77.341 28.5967 77.4755 28.7715 77.5965 28.9329L79.7953 32.1672ZM72.6744 23.3048L72.977 26.4651L73.9655 26.3643C74.1862 26.3518 74.402 26.2933 74.5988 26.1926C74.7957 26.0918 74.9693 25.9511 75.1086 25.7793C75.3818 25.4233 75.5027 24.9736 75.4448 24.5286C75.3439 23.5401 74.7724 23.0896 73.7167 23.1838L72.6744 23.3048Z"
        fill="white"
      />
      <path
        d="M44.043 35.7445C43.3687 35.8256 42.6847 35.7547 42.0413 35.5372C41.3979 35.3196 40.8113 34.9608 40.3245 34.4871C39.2483 33.4134 38.6188 31.9718 38.5628 30.4526C38.3376 28.8868 38.6837 27.2923 39.5378 25.9609C39.9344 25.3755 40.4602 24.8892 41.0746 24.5394C41.6891 24.1897 42.3757 23.9858 43.0815 23.9436C43.7477 23.86 44.4243 23.9298 45.0595 24.1477C45.6946 24.3657 46.2716 24.7259 46.7461 25.201C47.7904 26.295 48.4103 27.7255 48.4944 29.2355C48.7162 30.7905 48.37 32.3732 47.5194 33.6936C47.1413 34.2841 46.6297 34.7774 46.0258 35.1336C45.4219 35.4899 44.7427 35.6991 44.043 35.7445ZM43.2361 26.176C42.8565 26.2042 42.4905 26.329 42.1728 26.5385C41.855 26.748 41.5961 27.0352 41.4206 27.3729C40.9924 28.2195 40.8329 29.1767 40.9633 30.1164C40.9971 31.0644 41.3341 31.9765 41.9249 32.7186C42.1578 33.004 42.4579 33.227 42.7982 33.3679C43.1385 33.5087 43.5085 33.5629 43.8749 33.5255C44.2415 33.5031 44.5964 33.3884 44.9067 33.1921C45.2171 32.9958 45.4728 32.7242 45.6501 32.4026C46.081 31.5763 46.2365 30.6339 46.0939 29.7129C46.0559 28.7414 45.7254 27.8039 45.1458 27.0233C44.9315 26.7302 44.6446 26.4979 44.3133 26.3494C43.982 26.2008 43.6177 26.1411 43.2563 26.176H43.2361Z"
        fill="#FFCB00"
      />
      <path
        d="M55.1714 25.1204L51.5874 25.4566L51.8631 28.2471L55.158 27.9311L55.3597 30.0088L52.0581 30.3316L52.4818 34.7561L50.1956 34.9712L49.1197 23.5873L55.0033 23.0359L55.1714 25.1204Z"
        fill="#FFCB00"
      />
      <path
        d="M62.1444 24.4614L58.5672 24.7976L58.8361 27.5881L62.131 27.2721L62.3327 29.3566L59.0379 29.6793L59.4548 34.0971L57.1753 34.319L56.0927 22.935L61.9763 22.3836L62.1444 24.4614Z"
        fill="#FFCB00"
      />
      <path
        d="M70.2134 33.075L64.1146 33.6398L63.0387 22.2626L68.9022 21.7112L69.1106 23.789L65.5267 24.1252L65.762 26.6535L69.1241 26.3643L69.3258 28.4488L65.9974 28.7716L66.2462 31.3738L70.0655 31.0174L70.2134 33.075Z"
        fill="#FFCB00"
      />
      <path
        d="M79.7953 32.1672L77.1594 32.416L75.3103 29.6255C75.192 29.4283 75.057 29.2416 74.9068 29.0674C74.7957 28.9181 74.672 28.7786 74.537 28.6505C74.4292 28.5465 74.3041 28.4623 74.1672 28.4017C74.0383 28.3534 73.9013 28.3305 73.7637 28.3345L73.1451 28.3815L73.562 32.732L71.2758 32.9539L70.2 21.57L73.831 21.2338C76.2987 21.0051 77.6301 21.9062 77.8654 23.9772C77.9022 24.3483 77.8795 24.7228 77.7982 25.0867C77.7238 25.4218 77.5991 25.7437 77.4284 26.0415C77.2491 26.3351 77.0218 26.5965 76.756 26.8148C76.4836 27.0391 76.1829 27.2268 75.8617 27.3729C76.0291 27.4188 76.1881 27.4915 76.3324 27.5881C76.4887 27.7036 76.6391 27.827 76.7829 27.9579C76.9378 28.1043 77.0795 28.2641 77.2065 28.4353C77.341 28.5967 77.4755 28.7715 77.5965 28.9329L79.7953 32.1672ZM72.6744 23.3048L72.977 26.4651L73.9655 26.3643C74.1862 26.3518 74.402 26.2933 74.5988 26.1926C74.7957 26.0918 74.9693 25.9511 75.1086 25.7793C75.3818 25.4233 75.5027 24.9736 75.4448 24.5286C75.3439 23.5401 74.7724 23.0896 73.7167 23.1838L72.6744 23.3048Z"
        fill="#FFCB00"
      />
      <path
        d="M44.043 35.7445C43.3687 35.8256 42.6847 35.7547 42.0413 35.5372C41.3979 35.3196 40.8113 34.9608 40.3245 34.4871C39.2483 33.4134 38.6188 31.9718 38.5628 30.4526C38.3376 28.8868 38.6837 27.2923 39.5378 25.9609C39.9344 25.3755 40.4602 24.8892 41.0746 24.5394C41.6891 24.1897 42.3757 23.9858 43.0815 23.9436C43.7477 23.86 44.4243 23.9298 45.0595 24.1477C45.6946 24.3657 46.2716 24.7259 46.7461 25.201C47.7904 26.295 48.4103 27.7255 48.4944 29.2355C48.7162 30.7905 48.37 32.3732 47.5194 33.6936C47.1413 34.2841 46.6297 34.7774 46.0258 35.1336C45.4219 35.4899 44.7427 35.6991 44.043 35.7445ZM43.2361 26.176C42.8565 26.2042 42.4905 26.329 42.1728 26.5385C41.855 26.748 41.5961 27.0352 41.4206 27.3729C40.9924 28.2195 40.8329 29.1767 40.9633 30.1164C40.9971 31.0644 41.3341 31.9765 41.9249 32.7186C42.1578 33.004 42.4579 33.227 42.7982 33.3679C43.1385 33.5087 43.5085 33.5629 43.8749 33.5255C44.2415 33.5031 44.5964 33.3884 44.9067 33.1921C45.2171 32.9958 45.4728 32.7242 45.6501 32.4026C46.081 31.5763 46.2365 30.6339 46.0939 29.7129C46.0559 28.7414 45.7254 27.8039 45.1458 27.0233C44.9315 26.7302 44.6446 26.4979 44.3133 26.3494C43.982 26.2008 43.6177 26.1411 43.2563 26.176H43.2361Z"
        fill="#FFCB00"
      />
      <path
        d="M55.1714 25.1204L51.5874 25.4566L51.8631 28.2471L55.158 27.9311L55.3597 30.0088L52.0581 30.3316L52.4818 34.7561L50.1956 34.9712L49.1197 23.5873L55.0033 23.0359L55.1714 25.1204Z"
        fill="#FFCB00"
      />
      <path
        d="M62.1444 24.4614L58.5672 24.7976L58.8361 27.5881L62.131 27.2721L62.3327 29.3566L59.0379 29.6793L59.4548 34.0971L57.1753 34.319L56.0927 22.935L61.9763 22.3836L62.1444 24.4614Z"
        fill="#FFCB00"
      />
      <path
        d="M70.2134 33.075L64.1146 33.6398L63.0387 22.2626L68.9022 21.7112L69.1106 23.789L65.5267 24.1252L65.762 26.6535L69.1241 26.3643L69.3258 28.4488L65.9974 28.7716L66.2462 31.3738L70.0655 31.0174L70.2134 33.075Z"
        fill="#FFCB00"
      />
      <path
        d="M79.7953 32.1672L77.1594 32.416L75.3103 29.6255C75.192 29.4283 75.057 29.2416 74.9068 29.0674C74.7957 28.9181 74.672 28.7786 74.537 28.6505C74.4292 28.5465 74.3041 28.4623 74.1672 28.4017C74.0383 28.3534 73.9013 28.3305 73.7637 28.3345L73.1451 28.3815L73.562 32.732L71.2758 32.9539L70.2 21.57L73.831 21.2338C76.2987 21.0051 77.6301 21.9062 77.8654 23.9772C77.9022 24.3483 77.8795 24.7228 77.7982 25.0867C77.7238 25.4218 77.5991 25.7437 77.4284 26.0415C77.2491 26.3351 77.0218 26.5965 76.756 26.8148C76.4836 27.0391 76.1829 27.2268 75.8617 27.3729C76.0291 27.4188 76.1881 27.4915 76.3324 27.5881C76.4887 27.7036 76.6391 27.827 76.7829 27.9579C76.9378 28.1043 77.0795 28.2641 77.2065 28.4353C77.341 28.5967 77.4755 28.7715 77.5965 28.9329L79.7953 32.1672ZM72.6744 23.3048L72.977 26.4651L73.9655 26.3643C74.1862 26.3518 74.402 26.2933 74.5988 26.1926C74.7957 26.0918 74.9693 25.9511 75.1086 25.7793C75.3818 25.4233 75.5027 24.9736 75.4448 24.5286C75.3439 23.5401 74.7724 23.0896 73.7167 23.1838L72.6744 23.3048Z"
        fill="#FFCB00"
      />
      <path
        d="M44.043 35.7445C43.3687 35.8256 42.6847 35.7547 42.0413 35.5372C41.3979 35.3196 40.8113 34.9608 40.3245 34.4871C39.2483 33.4134 38.6188 31.9718 38.5628 30.4526C38.3376 28.8868 38.6837 27.2923 39.5378 25.9609C39.9344 25.3755 40.4602 24.8892 41.0746 24.5394C41.6891 24.1897 42.3757 23.9858 43.0815 23.9436C43.7477 23.86 44.4243 23.9298 45.0595 24.1477C45.6946 24.3657 46.2716 24.7259 46.7461 25.201C47.7904 26.295 48.4103 27.7255 48.4944 29.2355C48.7162 30.7905 48.37 32.3732 47.5194 33.6936C47.1413 34.2841 46.6297 34.7774 46.0258 35.1336C45.4219 35.4899 44.7427 35.6991 44.043 35.7445ZM43.2361 26.176C42.8565 26.2042 42.4905 26.329 42.1728 26.5385C41.855 26.748 41.5961 27.0352 41.4206 27.3729C40.9924 28.2195 40.8329 29.1767 40.9633 30.1164C40.9971 31.0644 41.3341 31.9765 41.9249 32.7186C42.1578 33.004 42.4579 33.227 42.7982 33.3679C43.1385 33.5087 43.5085 33.5629 43.8749 33.5255C44.2415 33.5031 44.5964 33.3884 44.9067 33.1921C45.2171 32.9958 45.4728 32.7242 45.6501 32.4026C46.081 31.5763 46.2365 30.6339 46.0939 29.7129C46.0559 28.7414 45.7254 27.8039 45.1458 27.0233C44.9315 26.7302 44.6446 26.4979 44.3133 26.3494C43.982 26.2008 43.6177 26.1411 43.2563 26.176H43.2361Z"
        fill="#0A0A0A"
      />
      <path
        d="M55.1714 25.1204L51.5874 25.4566L51.8631 28.2471L55.158 27.9311L55.3597 30.0088L52.0581 30.3316L52.4818 34.7561L50.1956 34.9712L49.1197 23.5873L55.0033 23.0359L55.1714 25.1204Z"
        fill="#0A0A0A"
      />
      <path
        d="M62.1444 24.4614L58.5672 24.7976L58.8361 27.5881L62.131 27.2721L62.3327 29.3566L59.0379 29.6793L59.4548 34.0971L57.1753 34.319L56.0927 22.935L61.9763 22.3836L62.1444 24.4614Z"
        fill="#0A0A0A"
      />
      <path
        d="M70.2134 33.075L64.1146 33.6398L63.0387 22.2626L68.9022 21.7112L69.1106 23.789L65.5267 24.1252L65.762 26.6535L69.1241 26.3643L69.3258 28.4488L65.9974 28.7716L66.2462 31.3738L70.0655 31.0174L70.2134 33.075Z"
        fill="#0A0A0A"
      />
      <path
        d="M79.7953 32.1672L77.1594 32.416L75.3103 29.6255C75.192 29.4283 75.057 29.2416 74.9068 29.0674C74.7957 28.9181 74.672 28.7786 74.537 28.6505C74.4292 28.5465 74.3041 28.4623 74.1672 28.4017C74.0383 28.3534 73.9013 28.3305 73.7637 28.3345L73.1451 28.3815L73.562 32.732L71.2758 32.9539L70.2 21.57L73.831 21.2338C76.2987 21.0051 77.6301 21.9062 77.8654 23.9772C77.9022 24.3483 77.8795 24.7228 77.7982 25.0867C77.7238 25.4218 77.5991 25.7437 77.4284 26.0415C77.2491 26.3351 77.0218 26.5965 76.756 26.8148C76.4836 27.0391 76.1829 27.2268 75.8617 27.3729C76.0291 27.4188 76.1881 27.4915 76.3324 27.5881C76.4887 27.7036 76.6391 27.827 76.7829 27.9579C76.9378 28.1043 77.0795 28.2641 77.2065 28.4353C77.341 28.5967 77.4755 28.7715 77.5965 28.9329L79.7953 32.1672ZM72.6744 23.3048L72.977 26.4651L73.9655 26.3643C74.1862 26.3518 74.402 26.2933 74.5988 26.1926C74.7957 26.0918 74.9693 25.9511 75.1086 25.7793C75.3818 25.4233 75.5027 24.9736 75.4448 24.5286C75.3439 23.5401 74.7724 23.0896 73.7167 23.1838L72.6744 23.3048Z"
        fill="#0A0A0A"
      />
      <path
        d="M39.6185 17.9793L39.5042 16.7488C39.6447 16.8697 39.8036 16.9673 39.9749 17.0379C40.1542 17.117 40.3384 17.1844 40.5263 17.2397C40.7166 17.2863 40.9098 17.32 41.1046 17.3405C41.2814 17.354 41.459 17.354 41.6358 17.3405C42.0828 17.3285 42.5113 17.1595 42.8461 16.8631C42.9742 16.7217 43.0696 16.5538 43.1253 16.3713C43.1811 16.1888 43.196 15.9963 43.1689 15.8074C43.1544 15.5855 43.0851 15.3706 42.9672 15.1821C42.852 15.0115 42.7114 14.8596 42.5503 14.7316C42.3602 14.5901 42.1576 14.4663 41.9451 14.3617C41.7097 14.2474 41.4542 14.1264 41.1853 14.0121C40.9163 13.8978 40.6272 13.7431 40.3985 13.6019C40.1566 13.4749 39.9308 13.3191 39.7261 13.1379C39.5396 12.9536 39.381 12.7429 39.2554 12.5126C39.1239 12.2453 39.0441 11.9556 39.0201 11.6586C38.975 11.2922 39.0212 10.9203 39.1546 10.576C39.2666 10.2698 39.4512 9.99519 39.6925 9.77587C39.9296 9.55627 40.2025 9.37889 40.4994 9.25139C40.8057 9.13056 41.1269 9.0514 41.4542 9.01604C42.0197 8.9244 42.5992 8.98235 43.1353 9.18415L43.2563 10.3609C42.7195 10.0249 42.0813 9.88922 41.4542 9.9776C41.2551 9.99828 41.0589 10.0411 40.8692 10.1054C40.689 10.1788 40.5194 10.2761 40.3649 10.3945C40.2183 10.5155 40.103 10.67 40.0287 10.845C39.9405 11.0574 39.9103 11.2895 39.9413 11.5174C39.9569 11.7197 40.0141 11.9166 40.1094 12.0957C40.2087 12.2563 40.3363 12.3976 40.486 12.5126C40.6587 12.6457 40.8433 12.7628 41.0373 12.8623C41.2592 12.9631 41.508 13.1043 41.7905 13.2186C42.0729 13.3329 42.3687 13.4876 42.6175 13.6355C42.8751 13.7783 43.1125 13.9547 43.3235 14.16C43.5215 14.3601 43.6912 14.5863 43.8278 14.8324C43.9696 15.1066 44.0564 15.4058 44.0834 15.7133C44.1264 16.0964 44.0851 16.4842 43.9623 16.8497C43.8496 17.1527 43.673 17.4279 43.4446 17.6566C43.2106 17.882 42.9275 18.0501 42.6175 18.1474C42.2882 18.2655 41.9443 18.3378 41.5954 18.3626C41.4432 18.3743 41.2904 18.3743 41.1382 18.3626C40.9535 18.3606 40.7692 18.3448 40.5868 18.3155C40.3985 18.2752 40.217 18.2416 40.0489 18.1945C39.8999 18.1345 39.756 18.0625 39.6185 17.9793Z"
        fill="#0A0A0A"
      />
      <path
        d="M46.4301 14.2945L46.7529 17.6566L45.8586 17.7372L45.018 8.82777L47.1227 8.63277C47.468 8.57485 47.8216 8.59107 48.1601 8.68034C48.4987 8.76961 48.8143 8.92989 49.0861 9.15053C49.3508 9.39587 49.5634 9.69198 49.7113 10.0212C49.8592 10.3504 49.9393 10.7061 49.9468 11.0669C50.0516 11.8276 49.8509 12.5988 49.3887 13.2119C49.1558 13.5098 48.8606 13.7532 48.5238 13.9251C48.187 14.097 47.8166 14.1933 47.4387 14.2071L46.4301 14.2945ZM45.993 9.72208L46.3494 13.3733L47.2841 13.2859C47.8087 13.2677 48.3056 13.0458 48.6692 12.6672C48.8257 12.463 48.9377 12.2282 48.9979 11.9781C49.0581 11.7279 49.0653 11.4679 49.0189 11.2148C49.0273 10.9693 48.9785 10.7252 48.8765 10.5018C48.7744 10.2783 48.6219 10.0816 48.4309 9.9271C48.2399 9.77261 48.0157 9.66458 47.7758 9.6115C47.536 9.55842 47.287 9.56174 47.0487 9.62121L45.993 9.72208Z"
        fill="#0A0A0A"
      />
      <path
        d="M56.0456 16.769L51.9775 17.1522L51.137 8.24276L55.037 7.87293L55.1177 8.81431L52.1322 9.10345L52.4146 12.0621L55.1917 11.7931L55.2724 12.7278L52.4953 13.0034L52.7844 16.11L55.938 15.8074L56.0456 16.769Z"
        fill="#0A0A0A"
      />
      <path
        d="M62.7227 15.7738C62.1108 16.1977 61.3946 16.4465 60.6517 16.4933C60.1509 16.5581 59.642 16.5036 59.1663 16.3342C58.6907 16.1647 58.2619 15.8851 57.9149 15.5183C57.1383 14.6626 56.6801 13.5656 56.6172 12.4117C56.4416 11.1696 56.7158 9.90558 57.3904 8.84792C57.6877 8.39662 58.085 8.01991 58.5515 7.74703C59.0179 7.47416 59.541 7.31245 60.0801 7.27447C60.7033 7.19683 61.336 7.26355 61.9292 7.46947L62.0301 8.57896C61.4544 8.28272 60.8046 8.16118 60.1608 8.2293C59.7472 8.26233 59.3469 8.39059 58.9911 8.60406C58.6353 8.81753 58.3337 9.11042 58.1099 9.45982C57.6011 10.3051 57.4059 11.3025 57.5585 12.2772C57.5933 13.2091 57.9497 14.1001 58.5672 14.7988C58.83 15.0855 59.1575 15.3053 59.5224 15.4398C59.8873 15.5743 60.2791 15.6196 60.6651 15.5721C61.3848 15.5265 62.0709 15.2507 62.6218 14.7853L62.7227 15.7738Z"
        fill="#0A0A0A"
      />
      <path
        d="M65.1098 6.93157L65.1905 7.81915L64.4374 7.88639L65.1098 15.0005L65.8629 14.9333L65.9436 15.8276L63.543 16.0562L63.4623 15.1686L64.2154 15.1014L63.543 7.98725L62.7899 8.0545L62.7025 7.16691L65.1098 6.93157Z"
        fill="#0A0A0A"
      />
      <path
        d="M73.1586 15.1552L72.1701 15.256L71.1279 12.8286L67.8599 13.1312L67.3422 15.7066L66.3336 15.8074L68.4382 6.62897L69.3595 6.54155L73.1586 15.1552ZM70.7379 11.9074L69.1779 8.22259C69.0977 8.03537 69.0412 7.83884 69.0098 7.63759C68.9997 7.8405 68.9773 8.0426 68.9426 8.24277L68.102 12.1428L70.7379 11.9074Z"
        fill="#0A0A0A"
      />
      <path
        d="M78.2689 14.6643L74.3017 15.0341L73.4679 6.12466L74.3555 6.04397L75.1086 14.0121L78.1882 13.7229L78.2689 14.6643Z"
        fill="#0A0A0A"
      />
      <path
        d="M28.5773 20.716C28.5773 20.7631 28.4832 20.716 28.5168 20.6488C30.9154 16.5729 33.6124 12.6802 36.5857 9.00257L37.8095 9.97757C34.9905 13.7713 31.9053 17.3598 28.5773 20.716Z"
        fill="#0A0A0A"
      />
      <path
        d="M42.1735 22.0944L41.9113 20.8841C40.5935 20.9817 39.2902 21.223 38.0247 21.6036C35.9656 22.0266 33.9335 22.5722 31.9394 23.2375C31.9058 23.2375 31.9394 23.3048 31.9394 23.3048C34.0508 23.253 36.157 23.0734 38.2467 22.7668C39.5774 22.6966 40.8953 22.4709 42.1735 22.0944Z"
        fill="#0A0A0A"
      />
      <path
        d="M29.3709 7.52325L28.1874 7.30135C27.7827 8.50587 27.5077 9.75016 27.3671 11.0131C26.9655 13.0123 26.6782 15.0328 26.5064 17.0648C26.5095 17.072 26.5147 17.0781 26.5213 17.0824C26.5279 17.0867 26.5355 17.089 26.5434 17.089C26.5512 17.089 26.5589 17.0867 26.5655 17.0824C26.5721 17.0781 26.5773 17.072 26.5804 17.0648C27.3211 15.1631 27.9542 13.2213 28.4766 11.2484C28.9331 10.0501 29.2337 8.79816 29.3709 7.52325Z"
        fill="#0A0A0A"
      />
      <path
        d="M34.6292 30.735C34.9829 30.4122 35.1952 29.9631 35.2204 29.485C35.2456 29.0068 35.0815 28.538 34.7637 28.1798L22.1694 14.2609C21.8601 13.9328 21.4395 13.7321 20.9899 13.6981C20.5404 13.664 20.0943 13.7991 19.7391 14.0768C19.384 14.3546 19.1453 14.7549 19.07 15.1994C18.9946 15.6439 19.088 16.1006 19.3318 16.4798L14.3223 26.6803L10.0659 30.5198C9.78407 30.7726 9.56141 31.0844 9.41381 31.4331C9.2662 31.7818 9.19731 32.1587 9.21201 32.5371L9.27924 33.7945L8.60682 34.3996C8.145 34.8269 7.86881 35.418 7.83739 36.0464C7.80597 36.6748 8.02182 37.2905 8.43872 37.7617L9.88442 39.3755C10.3138 39.8458 10.9116 40.1273 11.5476 40.1588C12.1837 40.1902 12.8064 39.9691 13.2801 39.5436L13.9525 38.9384L15.1965 39.1267C15.5396 39.1766 15.8892 39.1583 16.2253 39.0729L22.862 46.4157C23.0014 46.5725 23.1704 46.7001 23.3594 46.7912C23.5484 46.8822 23.7536 46.9349 23.9631 46.9462C24.1725 46.9574 24.3822 46.927 24.5798 46.8567C24.7775 46.7865 24.9592 46.6777 25.1146 46.5367L26.0089 45.7298C26.1692 45.5835 26.2981 45.4062 26.3878 45.2085C26.4774 45.0108 26.5259 44.797 26.5303 44.58C26.5347 44.363 26.4949 44.1474 26.4134 43.9462C26.3318 43.7451 26.2102 43.5627 26.056 43.41C24.8123 42.1711 23.7991 40.7207 23.0637 39.1267L24.0051 38.2862C24.2887 38.0303 24.4589 37.6722 24.4785 37.2908C24.498 36.9093 24.3652 36.5357 24.1093 36.2521C23.8534 35.9686 23.4953 35.7983 23.1139 35.7788C22.7324 35.7592 22.3588 35.892 22.0753 36.1479C21.9512 35.6199 21.8547 35.0857 21.7862 34.5476L32.0741 30.5131C32.3838 30.8809 32.8267 31.1108 33.3058 31.1524C33.7848 31.194 34.2608 31.0439 34.6292 30.735Z"
        fill="#0A0A0A"
      />
      <path
        d="M15.2973 38.4812L13.8853 38.266C13.8316 38.2588 13.7769 38.2628 13.7248 38.2778C13.6727 38.2929 13.6243 38.3186 13.5827 38.3534L12.7758 39.0729C12.4458 39.3724 12.0104 39.5285 11.5653 39.5071C11.1202 39.4856 10.7019 39.2884 10.4022 38.9586L8.96322 37.3448C8.66379 37.0148 8.50761 36.5794 8.52905 36.1344C8.55048 35.6893 8.74776 35.2709 9.07752 34.9712L9.88442 34.2517C9.9235 34.2145 9.95441 34.1696 9.97525 34.1199C9.99608 34.0701 10.0064 34.0165 10.0055 33.9626L9.93823 32.5303C9.92215 32.2548 9.9675 31.9792 10.071 31.7234C10.1745 31.4675 10.3335 31.2379 10.5366 31.051L14.5711 27.4066L20.865 34.366L16.8305 38.0105C16.7025 38.1249 16.56 38.2221 16.4068 38.2997L11.8546 33.2566C11.7922 33.1852 11.704 33.1416 11.6094 33.1353C11.5148 33.129 11.4216 33.1605 11.3503 33.2229C11.2789 33.2853 11.2353 33.3735 11.229 33.4681C11.2227 33.5627 11.2543 33.6559 11.3167 33.7272L15.5999 38.4812C15.5009 38.5081 15.3964 38.5081 15.2973 38.4812Z"
        fill="white"
      />
      <path
        d="M17.3146 38.5686L21.1003 35.1393C21.4037 37.3472 22.1838 39.4627 23.3865 41.339L21.0465 43.4436L16.8977 38.851C17.0492 38.7768 17.1895 38.6817 17.3146 38.5686Z"
        fill="#FFCB00"
      />
      <path
        d="M22.5258 45.0574L21.5575 43.9816L23.8101 41.9643C24.0802 42.3646 24.3767 42.7465 24.6977 43.1074L22.5258 45.0574Z"
        fill="white"
      />
      <path
        d="M15.0284 26.8485L19.8227 17.0648L31.5362 30.029L21.4836 33.9828L15.0284 26.8485Z"
        fill="#FFCB00"
      />
      <path
        d="M12.5539 37.0221L11.2091 38.2324C11.1742 38.2645 11.1464 38.3035 11.1274 38.3469C11.1084 38.3903 11.0986 38.4372 11.0986 38.4846C11.0986 38.532 11.1084 38.5788 11.1274 38.6222C11.1464 38.6656 11.1742 38.7046 11.2091 38.7367C11.2417 38.7707 11.2808 38.7977 11.3242 38.8162C11.3675 38.8346 11.4141 38.8442 11.4612 38.8442C11.5083 38.8442 11.5549 38.8346 11.5982 38.8162C11.6416 38.7977 11.6807 38.7707 11.7134 38.7367L13.0582 37.5264C13.1225 37.4568 13.1582 37.3656 13.1582 37.2709C13.1582 37.1762 13.1225 37.0849 13.0582 37.0154C12.9896 36.9509 12.8988 36.9156 12.8047 36.9169C12.7106 36.9181 12.6207 36.9558 12.5539 37.0221Z"
        fill="#0A0A0A"
      />
      <path
        d="M11.5788 35.9462L10.234 37.1565C10.1667 37.2245 10.1289 37.3163 10.1289 37.412C10.1289 37.5077 10.1667 37.5996 10.234 37.6676C10.3025 37.7314 10.3926 37.7668 10.4862 37.7668C10.5798 37.7668 10.6699 37.7314 10.7383 37.6676L12.0832 36.4639C12.1163 36.4308 12.1426 36.3915 12.1606 36.3483C12.1785 36.305 12.1877 36.2586 12.1877 36.2118C12.1877 36.1649 12.1785 36.1186 12.1606 36.0753C12.1426 36.032 12.1163 35.9927 12.0832 35.9596C12.0164 35.894 11.9273 35.8561 11.8337 35.8536C11.7401 35.8511 11.649 35.8842 11.5788 35.9462Z"
        fill="#0A0A0A"
      />
      <path
        d="M10.624 34.8905L9.27918 36.1009C9.24541 36.1329 9.21852 36.1715 9.20014 36.2143C9.18176 36.257 9.17227 36.3031 9.17227 36.3497C9.17227 36.3962 9.18176 36.4423 9.20014 36.4851C9.21852 36.5278 9.24541 36.5664 9.27918 36.5985C9.3124 36.6326 9.35214 36.6598 9.39603 36.6783C9.43991 36.6969 9.48706 36.7064 9.5347 36.7064C9.58235 36.7064 9.62949 36.6969 9.67338 36.6783C9.71727 36.6598 9.75701 36.6326 9.79022 36.5985L11.1351 35.3881C11.1705 35.3573 11.1995 35.3198 11.2204 35.2777C11.2413 35.2356 11.2536 35.1898 11.2567 35.143C11.2599 35.0961 11.2537 35.0491 11.2386 35.0046C11.2234 34.9601 11.1997 34.9191 11.1687 34.8838C11.0949 34.8136 10.9967 34.7751 10.895 34.7763C10.7932 34.7776 10.696 34.8186 10.624 34.8905Z"
        fill="#0A0A0A"
      />
      <path
        d="M20.0714 14.6643C20.1772 14.5682 20.3011 14.4941 20.4359 14.4463C20.5707 14.3986 20.7136 14.3782 20.8563 14.3863C20.9991 14.3945 21.1388 14.431 21.2672 14.4937C21.3957 14.5565 21.5104 14.6442 21.6046 14.7517L34.1921 28.664C34.3847 28.878 34.4844 29.1597 34.4693 29.4472C34.4542 29.7348 34.3254 30.0045 34.1114 30.1971C33.8974 30.3897 33.6157 30.4894 33.3282 30.4743C33.0407 30.4591 32.771 30.3304 32.5784 30.1164L19.984 16.1907C19.7985 15.9743 19.704 15.6945 19.7203 15.4099C19.7366 15.1253 19.8624 14.8581 20.0714 14.6643Z"
        fill="white"
      />
      <path
        d="M25.5046 45.2793L24.6103 46.0862C24.5258 46.1633 24.4268 46.2227 24.319 46.2609C24.2112 46.299 24.0969 46.3151 23.9827 46.3082C23.8686 46.3013 23.757 46.2715 23.6546 46.2207C23.5522 46.1699 23.461 46.099 23.3865 46.0122L22.9965 45.5954L25.1616 43.6252C25.2781 43.7551 25.4015 43.8786 25.5315 43.995C25.6149 44.0806 25.6805 44.182 25.7244 44.2932C25.7683 44.4044 25.7896 44.5233 25.7871 44.6428C25.7846 44.7623 25.7583 44.8802 25.7098 44.9894C25.6613 45.0987 25.5915 45.1973 25.5046 45.2793Z"
        fill="#FFCB00"
      />
      <path
        d="M22.5258 36.7733C22.5957 36.7088 22.6778 36.6588 22.7672 36.6262C22.8566 36.5936 22.9516 36.5791 23.0466 36.5835C23.1417 36.5878 23.2349 36.611 23.321 36.6517C23.407 36.6924 23.4841 36.7497 23.5478 36.8204C23.6121 36.8913 23.6618 36.9743 23.6939 37.0645C23.726 37.1547 23.74 37.2503 23.735 37.3459C23.73 37.4416 23.7061 37.5352 23.6647 37.6216C23.6234 37.708 23.5654 37.7853 23.494 37.8491L22.7409 38.5216C22.5378 38.0342 22.3692 37.5332 22.2366 37.0221L22.5258 36.7733Z"
        fill="white"
      />
      <path
        d="M21.0464 20.5816C21.0133 20.6147 20.987 20.654 20.9691 20.6972C20.9511 20.7405 20.9419 20.7869 20.9419 20.8337C20.9419 20.8805 20.9511 20.9269 20.9691 20.9702C20.987 21.0135 21.0133 21.0528 21.0464 21.0859L27.8176 28.5833C27.8507 28.6164 27.8901 28.6427 27.9333 28.6606C27.9766 28.6786 28.023 28.6878 28.0698 28.6878C28.1166 28.6878 28.163 28.6786 28.2063 28.6606C28.2496 28.6427 28.2889 28.6164 28.3219 28.5833C28.3559 28.5507 28.3829 28.5115 28.4014 28.4682C28.4199 28.4248 28.4294 28.3782 28.4294 28.3311C28.4294 28.284 28.4199 28.2374 28.4014 28.1941C28.3829 28.1507 28.3559 28.1116 28.3219 28.079L21.5507 20.6152C21.5204 20.5789 21.4831 20.5492 21.441 20.5278C21.3989 20.5064 21.3529 20.4937 21.3058 20.4906C21.2586 20.4875 21.2114 20.4939 21.1668 20.5095C21.1222 20.5252 21.0813 20.5497 21.0464 20.5816Z"
        fill="#0A0A0A"
      />
      <path
        d="M21.6516 23.9436C21.6177 23.9763 21.5906 24.0154 21.5722 24.0587C21.5537 24.1021 21.5442 24.1487 21.5442 24.1958C21.5442 24.2429 21.5537 24.2895 21.5722 24.3328C21.5906 24.3762 21.6177 24.4153 21.6516 24.4479L24.5632 27.6554C24.6264 27.7249 24.7137 27.7678 24.8074 27.7753C24.901 27.7827 24.9941 27.7543 25.0675 27.6957C25.1299 27.6265 25.1644 27.5367 25.1644 27.4435C25.1644 27.3504 25.1299 27.2606 25.0675 27.1914L22.1559 23.9773C22.0918 23.9087 22.0041 23.8671 21.9104 23.8608C21.8168 23.8546 21.7243 23.8842 21.6516 23.9436Z"
        fill="#0A0A0A"
      />
      <path
        d="M21.033 25.9609C20.9677 26.0286 20.9312 26.119 20.9312 26.213C20.9312 26.3071 20.9677 26.3975 21.033 26.4652L22.4787 28.079C22.5471 28.1428 22.6372 28.1783 22.7308 28.1783C22.8244 28.1783 22.9145 28.1428 22.983 28.079C23.0161 28.0459 23.0424 28.0066 23.0604 27.9633C23.0783 27.92 23.0875 27.8737 23.0875 27.8268C23.0875 27.78 23.0783 27.7336 23.0604 27.6903C23.0424 27.6471 23.0161 27.6078 22.983 27.5747L21.5373 25.9609C21.5079 25.9219 21.4697 25.8902 21.426 25.8685C21.3822 25.8467 21.334 25.8353 21.2852 25.8353C21.2363 25.8353 21.1881 25.8467 21.1443 25.8685C21.1006 25.8902 21.0625 25.9219 21.033 25.9609Z"
        fill="#0A0A0A"
      />
    </svg>
  );
};

export const SubscriptionCardGreenTick = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="rgba(25,229,128,1)"
    >
      <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"></path>
    </svg>
  );
};

export const SubscriptionCardRedCross = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="rgba(254,0,0,1)"
    >
      <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 10.5858L9.17157 7.75736L7.75736 9.17157L10.5858 12L7.75736 14.8284L9.17157 16.2426L12 13.4142L14.8284 16.2426L16.2426 14.8284L13.4142 12L16.2426 9.17157L14.8284 7.75736L12 10.5858Z"></path>
    </svg>
  );
};
